import { useEffect } from "react";

// useVisibilityPolling adapts an Apollo query's poll cadence to tab visibility:
// it polls every foregroundMs while the tab is visible and backs off to
// backgroundMs when the tab is hidden (backgrounded), cutting needless requests
// when no one is looking. Pass the `startPolling` function returned by useQuery.
export function useVisibilityPolling(startPolling, foregroundMs, backgroundMs) {
  useEffect(() => {
    if (!startPolling) return undefined;

    const applyInterval = () =>
      startPolling(document.hidden ? backgroundMs : foregroundMs);

    applyInterval();
    document.addEventListener("visibilitychange", applyInterval);
    return () =>
      document.removeEventListener("visibilitychange", applyInterval);
  }, [startPolling, foregroundMs, backgroundMs]);
}
